import Vue from 'vue';
import recipeIngredienceTransformer from '../../transformers/recipeIngredience';
import store from '../../store';

const success = (resolve, response) => {
  recipeIngredienceTransformer.fetchCollection(response.data).forEach((data) => {
    store.dispatch('addRecipeIngredience', data);
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(recipeIngredienceTransformer.fetch(errors));
};

export default (recipeId, ingrediences) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/production/recipe/${recipeId}/recipe_ingredience/bulk`, { items: recipeIngredienceTransformer.sendCollection(ingrediences) })
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipeIngredience/bulkStore.js